import config from 'config'

import account from './views/Account.vue'
import accountUpdatePassword from './views/AccountUpdatePassword.vue'
import accountUpdateProfile from './views/AccountUpdateProfile.vue'
import city from './views/City.vue'
import confirmation from './views/Confirmation.vue'
import exclusiveEvents from './views/ExclusiveEvents.vue'
import forgotPassword from './views/ForgotPassword.vue'
import help from './views/Help.vue'
import home from './views/Home.vue'
import league from './views/League.vue'
import login from './views/Login.vue'
import logout from './views/Logout.vue'
import notFound from './views/NotFound.vue'
import performer from './views/Performer.vue'
import privacy from './views/Privacy.vue'
import purchases from './views/Purchases.vue'
import register from './views/Register.vue'
import resetPassword from './views/ResetPassword.vue'
import search from './views/Search.vue'
import unauthorized from './views/Unauthorized.vue'
import venue from './views/Venue.vue'
import PromotedEvents from './views/PromotedEvents.vue'

const checkout = () => import(/* webpackChunkName: "checkout" */ './views/Checkout.vue')
const event = () => import(/* webpackChunkName: "event" */ './views/Event.vue')
const ExclusiveEvent = () => import(/* webpackChunkName: "event" */ './views/ExclusiveEvent.vue')
const multiStepCheckout = () => import(/* webpackChunkName: "multiStepCheckout" */ './views/MultiStepCheckout.vue')

let routes = [
    {
        name: 'home',
        path: '/',
        component: home,
        meta: Object.assign({
            hasBigHeaderSearch: true,
            hasEvents: true,
            hasFooter: true,
            hasFooterNav: true,
            hasHeaderMenu: true,
            hasHeaderSearch: true,
            hasLiveChat: true,
            hasBulletin: true,
            hasFluidHeader: false,
            hasPartnerBanner: true,
            hasTallHeader: false,
            isFullHeight: false,
            isPublic: false
        }, config.routeMetaOverrides.home || {})
    },
    {
        name: 'unauthorized',
        path: '/unauthorized',
        component: unauthorized,
        meta: Object.assign({
            hasBigHeaderSearch: false,
            hasEvents: false,
            hasFooter: true,
            hasFooterNav: false,
            hasHeaderMenu: false,
            hasHeaderSearch: false,
            hasLiveChat: false,
            hasBulletin: false,
            hasFluidHeader: false,
            hasPartnerBanner: true,
            hasTallHeader: false,
            isFullHeight: false,
            isPublic: true
        }, config.routeMetaOverrides.unauthorized || {})
    },
    {
        name: 'checkout',
        path: '/checkout/:ticketId',
        props: true,
        component: config.hasMultiStepCheckout ? multiStepCheckout : checkout,
        meta: Object.assign({
            hasBigHeaderSearch: false,
            hasEvents: false,
            hasFooter: false,
            hasFooterNav: false,
            hasHeaderMenu: false,
            hasHeaderSearch: false,
            hasLiveChat: false,
            hasBulletin: true,
            hasFluidHeader: false,
            hasTallHeader: false,
            isFullHeight: false,
            isPublic: false
        }, config.routeMetaOverrides.checkout || {})
    },
    {
        name: 'help',
        path: '/help',
        props: false,
        component: help,
        meta: Object.assign({
            hasBigHeaderSearch: false,
            hasEvents: false,
            hasFooter: true,
            hasFooterNav: true,
            hasHeaderMenu: true,
            hasHeaderSearch: true,
            hasLiveChat: true,
            hasBulletin: true,
            hasFluidHeader: false,
            hasPartnerBanner: true,
            hasTallHeader: false,
            isFullHeight: false,
            isPublic: true
        }, config.routeMetaOverrides.help || {})
    },
    {
        name: 'privacy',
        path: '/privacy',
        props: false,
        component: privacy,
        meta: Object.assign({
            hasBigHeaderSearch: false,
            hasEvents: false,
            hasFooter: true,
            hasFooterNav: true,
            hasHeaderMenu: true,
            hasHeaderSearch: true,
            hasLiveChat: true,
            hasBulletin: true,
            hasFluidHeader: false,
            hasPartnerBanner: true,
            hasTallHeader: false,
            isFullHeight: false,
            isPublic: true
        }, config.routeMetaOverrides.help || {})
    },
    {
        name: 'order-confirmation',
        path: '/confirmation',
        props: true,
        component: confirmation,
        meta: Object.assign({
            hasHeaderMenu: true,
            hasHeaderSearch: true,
            hasLiveChat: false,
            isFullHeight: false,
            isPublic: false
        }, config.routeMetaOverrides['order-confirmation'] || {})
    },
    {
        name: 'logout',
        path: '/logout',
        component: logout,
        meta: Object.assign({
            hasBigHeaderSearch: false,
            hasEvents: false,
            hasFooter: true,
            hasFooterNav: false,
            hasBulletin: false,
            hasFluidHeader: false,
            hasPartnerBanner: true,
            hasLiveChat: false,
            hasTallHeader: false,
            isFullHeight: false,
            isPublic: true
        }, config.routeMetaOverrides.logout || {})
    },
    {
        name: 'purchases',
        path: '/tickets',
        redirect: {
            name: 'purchases-upcoming'
        }
    },
    {
        name: 'purchases-past',
        path: '/tickets/past',
        component: purchases,
        meta: Object.assign({
            hasBigHeaderSearch: false,
            hasEvents: false,
            hasFooter: true,
            hasFooterNav: true,
            hasBulletin: true,
            hasLiveChat: false,
            hasFluidHeader: false,
            hasPartnerBanner: true,
            hasTallHeader: false,
            isFullHeight: false,
            isPublic: false
        }, config.routeMetaOverrides['purchases-past'] || {})
    },
    {
        name: 'purchases-upcoming',
        path: '/tickets/upcoming',
        component: purchases,
        meta: Object.assign({
            hasBigHeaderSearch: false,
            hasEvents: false,
            hasFooter: true,
            hasFooterNav: true,
            hasBulletin: true,
            hasFluidHeader: false,
            hasPartnerBanner: true,
            hasLiveChat: false,
            hasTallHeader: false,
            isFullHeight: false,
            isPublic: false
        }, config.routeMetaOverrides['purchases-upcoming'] || {})
    },
    {
        name: 'search',
        path: '/search',
        component: search,
        meta: Object.assign({
            hasBigHeaderSearch: false,
            hasEvents: true,
            hasFooter: true,
            hasFooterNav: true,
            hasHeaderMenu: true,
            hasHeaderSearch: true,
            hasLiveChat: true,
            hasBulletin: true,
            hasFluidHeader: false,
            hasPartnerBanner: true,
            hasTallHeader: false,
            isFullHeight: false,
            isPublic: false
        }, config.routeMetaOverrides.search || {})
    },
    {
        name: 'event',
        path: '/events/:eventId',
        props: true,
        component: event,
        meta: Object.assign({
            hasBigHeaderSearch: false,
            hasEvents: false,
            hasFooter: false,
            hasHeaderMenu: true,
            hasHeaderSearch: true,
            hasLiveChat: false,
            hasBulletin: true,
            hasFluidHeader: true,
            hasTallHeader: false,
            isFullHeight: true,
            isPublic: false
        }, config.routeMetaOverrides.event || {})
    },
    {
        name: 'city',
        path: '/cities/:cityId',
        props: true,
        component: city,
        meta: Object.assign({
            hasBigHeaderSearch: false,
            hasEvents: true,
            hasFooter: true,
            hasFooterNav: true,
            hasHeaderMenu: true,
            hasHeaderSearch: true,
            hasLiveChat: true,
            hasBulletin: true,
            hasFluidHeader: false,
            hasPartnerBanner: true,
            hasTallHeader: true,
            isFullHeight: false,
            isPublic: false
        }, config.routeMetaOverrides.city || {})
    },
    {
        name: 'venue',
        path: '/venues/:venueId',
        props: true,
        component: venue,
        meta: Object.assign({
            hasBigHeaderSearch: false,
            hasEvents: true,
            hasFooter: true,
            hasFooterNav: true,
            hasHeaderMenu: true,
            hasHeaderSearch: true,
            hasLiveChat: true,
            hasBulletin: true,
            hasFluidHeader: false,
            hasPartnerBanner: true,
            hasTallHeader: true,
            isFullHeight: false,
            isPublic: false
        }, config.routeMetaOverrides.venue || {})
    },
    {
        name: 'performer',
        path: '/performers/:performerId',
        props: true,
        component: performer,
        meta: Object.assign({
            hasBigHeaderSearch: false,
            hasEvents: true,
            hasFooter: true,
            hasFooterNav: true,
            hasHeaderMenu: true,
            hasHeaderSearch: true,
            hasLiveChat: true,
            hasBulletin: true,
            hasFluidHeader: false,
            hasPartnerBanner: true,
            hasTallHeader: true,
            isFullHeight: false,
            isPublic: false
        }, config.routeMetaOverrides.performer || {})
    },
    {
        name: 'league',
        path: '/:leagueName(nba|nhl|nfl|mls|mlb)',
        props: true,
        component: league,
        meta: Object.assign({
            hasBigHeaderSearch: false,
            hasEvents: true,
            hasFooter: true,
            hasFooterNav: true,
            hasHeaderMenu: true,
            hasHeaderSearch: true,
            hasLiveChat: true,
            hasBulletin: true,
            hasFluidHeader: false,
            hasPartnerBanner: true,
            hasTallHeader: true,
            isFullHeight: false,
            isPublic: false
        }, config.routeMetaOverrides.league || {})
    },
    {
        name: 'campaign-hot-tours',
        path: '/campaign-hot-tours',
        props: true,
        component: PromotedEvents,
        meta: Object.assign({
            hasBigHeaderSearch: true,
            hasEvents: false,
            hasFooter: true,
            hasFooterNav: true,
            hasHeaderMenu: true,
            hasHeaderSearch: true,
            hasLiveChat: true,
            hasBulletin: true,
            hasFluidHeader: false,
            hasPartnerBanner: true,
            hasTallHeader: false,
            isFullHeight: false,
            // page is to be public for 'sn' users
            isPublic: Boolean(config.affiliateId === 105 || config.affiliateId === 1365)
        }, config.routeMetaOverrides.promotedEvents || {})
    }
]
if (config.hasExclusiveHighlights) {
    routes = routes.concat([
        {
            name: 'exclusive',
            path: '/exclusive-events',
            props: true,
            component: exclusiveEvents,
            meta: Object.assign({
                hasBigHeaderSearch: false,
                hasEvents: true,
                hasFooter: true,
                hasFooterNav: true,
                hasHeaderMenu: true,
                hasHeaderSearch: true,
                hasLiveChat: true,
                hasBulletin: true,
                hasFluidHeader: false,
                hasPartnerBanner: true,
                hasTallHeader: false,
                isFullHeight: false,
                isPublic: false
            }, config.routeMetaOverrides.event || {})
        }
    ])
}

if (config.hasExclusiveEventPage) {
    routes = routes.concat([
        {
            name: 'exclusive-event',
            path: '/exclusive-events/:eventId',
            props: true,
            component: ExclusiveEvent,
            meta: Object.assign({
                hasBigHeaderSearch: false,
                hasEvents: false,
                hasFooter: false,
                hasFooterNav: false,
                hasHeaderMenu: true,
                hasHeaderSearch: true,
                hasLiveChat: false,
                hasBulletin: true,
                hasFluidHeader: false,
                hasTallHeader: false,
                isFullHeight: false,
                isPublic: false
            }, config.routeMetaOverrides.event || {})
        }
    ])
}

if (config.auth && config.auth.isConcierge) {
    routes = routes.concat([
        {
            name: 'account',
            path: '/account',
            props: false,
            component: account,
            redirect: {
                name: 'account-profile'
            },
            children: [
                {
                    name: 'account-change-password',
                    path: 'change-password',
                    component: accountUpdatePassword,
                    meta: Object.assign({
                        hasBigHeaderSearch: false,
                        hasEvents: false,
                        hasFooter: true,
                        hasFooterNav: true,
                        hasHeaderMenu: false,
                        hasHeaderSearch: false,
                        hasLiveChat: false,
                        hasBulletin: false,
                        hasFluidHeader: false,
                        hasPartnerBanner: true,
                        hasTallHeader: false,
                        isFullHeight: false,
                        isPublic: false
                    }, config.routeMetaOverrides['account-change-password'] || {})
                },
                {
                    name: 'account-profile',
                    path: 'profile',
                    component: accountUpdateProfile,
                    meta: Object.assign({
                        hasBigHeaderSearch: false,
                        hasEvents: false,
                        hasFooter: true,
                        hasFooterNav: true,
                        hasHeaderMenu: false,
                        hasHeaderSearch: false,
                        hasLiveChat: false,
                        hasBulletin: false,
                        hasFluidHeader: false,
                        hasPartnerBanner: true,
                        hasTallHeader: false,
                        isFullHeight: false,
                        isPublic: false
                    }, config.routeMetaOverrides['account-profile'] || {})
                }
            ],
            meta: Object.assign({
                hasBigHeaderSearch: false,
                hasEvents: false,
                hasFooter: true,
                hasFooterNav: true,
                hasHeaderMenu: false,
                hasHeaderSearch: false,
                hasBulletin: false,
                hasFluidHeader: false,
                hasLiveChat: false,
                hasPartnerBanner: true,
                hasTallHeader: false,
                isFullHeight: false,
                isPublic: false
            }, config.routeMetaOverrides.account || {})
        },
        {
            name: 'forgot-password',
            path: '/forgot-password',
            component: forgotPassword,
            meta: Object.assign({
                hasBigHeaderSearch: false,
                hasEvents: false,
                hasFooter: true,
                hasFooterNav: true,
                hasHeaderMenu: false,
                hasHeaderSearch: false,
                hasBulletin: false,
                hasLiveChat: false,
                hasFluidHeader: false,
                hasPartnerBanner: true,
                hasTallHeader: false,
                isFullHeight: false,
                isPublic: true
            }, config.routeMetaOverrides['forgot-password'] || {})
        },
        {
            name: 'login',
            path: '/login',
            component: login,
            meta: Object.assign({
                hasBigHeaderSearch: false,
                hasEvents: false,
                hasFooter: true,
                hasFooterNav: true,
                hasHeaderMenu: false,
                hasHeaderSearch: false,
                hasLiveChat: false,
                hasBulletin: false,
                hasFluidHeader: false,
                hasTallHeader: false,
                isFullHeight: false,
                isPublic: true
            }, config.routeMetaOverrides.login || {})
        },
        {
            name: 'register',
            path: '/register',
            component: register,
            meta: Object.assign({
                hasBigHeaderSearch: false,
                hasEvents: false,
                hasFooter: true,
                hasFooterNav: true,
                hasHeaderMenu: false,
                hasHeaderSearch: false,
                hasLiveChat: false,
                hasBulletin: false,
                hasFluidHeader: false,
                hasTallHeader: false,
                isFullHeight: false,
                isPublic: true
            }, config.routeMetaOverrides.register || {})
        },
        {
            name: 'reset-password',
            path: '/reset-password/:token',
            component: resetPassword,
            props: true,
            meta: Object.assign({
                hasBigHeaderSearch: false,
                hasEvents: false,
                hasFooter: true,
                hasFooterNav: true,
                hasHeaderMenu: false,
                hasHeaderSearch: false,
                hasLiveChat: false,
                hasBulletin: false,
                hasFluidHeader: false,
                hasTallHeader: false,
                isFullHeight: false,
                isPublic: true
            }, config.routeMetaOverrides['reset-password'] || {})
        }
    ])
}

routes = routes.concat({
    name: 'not-found',
    path: '*',
    component: notFound,
    meta: Object.assign({
        hasBigHeaderSearch: true,
        hasEvents: false,
        hasFooter: true,
        hasHeaderMenu: true,
        hasHeaderSearch: true,
        hasLiveChat: false,
        hasBulletin: true,
        hasFluidHeader: false,
        hasPartnerBanner: true,
        hasTallHeader: false,
        isFullHeight: false,
        isPublic: true
    }, config.routeMetaOverrides['not-found'] || {})
})

export { routes }
